module.exports = __webpack_public_path__ + "static/img/shili_fan_bc.02d29e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shili_fan_bc.png
// module id = +yad
// module chunks = 62